import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
/** @jsx jsx */
import React, { useCallback } from 'react';
import { css, jsx } from '@emotion/react';
import { LoadingButton } from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import { SmartLinkSize } from '../../../../../../constants';
import { sizeToButtonSpacing } from '../../../utils';
var getButtonStyle = function getButtonStyle(size, iconOnly) {
  switch (size) {
    case SmartLinkSize.Large:
      return iconOnly ? css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            button,\n            button:hover,\n            button:focus,\n            button:active {\n              padding: 0;\n              > span {\n                margin: 0;\n              }\n            }\n          "]))) : '';
    case SmartLinkSize.Small:
      return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        font-size: 0.75rem;\n        font-weight: 500;\n        line-height: 1rem;\n        button,\n        button:hover,\n        button:focus,\n        button:active {\n          line-height: 1rem;\n          ", "\n        }\n      "])), iconOnly ? "\n            padding: 0.125rem;\n          " : "\n            padding-left: 0.25rem;\n            padding-right: 0.25rem;\n          ");
    case SmartLinkSize.XLarge:
    case SmartLinkSize.Medium:
    default:
      return '';
  }
};
var ActionButton = function ActionButton(_ref) {
  var appearance = _ref.appearance,
    content = _ref.content,
    iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    isLoading = _ref.isLoading,
    onClick = _ref.onClick,
    overrideCss = _ref.overrideCss,
    size = _ref.size,
    testId = _ref.testId,
    tooltipMessage = _ref.tooltipMessage,
    isDisabled = _ref.isDisabled;
  var iconOnly = !content;
  var onButtonClick = useCallback(function (handler) {
    return function (e) {
      e.preventDefault();
      handler();
    };
  }, []);
  return jsx("div", {
    css: [getButtonStyle(size, iconOnly), overrideCss],
    "data-testid": "".concat(testId, "-button-wrapper")
  }, jsx(Tooltip, {
    content: tooltipMessage,
    hideTooltipOnClick: true,
    testId: "".concat(testId, "-tooltip")
  }, jsx(LoadingButton, {
    appearance: appearance,
    iconAfter: iconAfter,
    iconBefore: iconBefore,
    isDisabled: isDisabled,
    isLoading: isLoading,
    onClick: onButtonClick(onClick),
    spacing: sizeToButtonSpacing[size],
    testId: testId
  }, content)));
};
export default ActionButton;